import React from 'react';
import { Alert } from '@mui/material';

export default function PreparationAlerts({
  t,
  error,
  metadataError,
  refreshError,
  refreshTask,
  refreshFailed,
  refreshSucceeded,
  refreshStatusLabel,
  regimeWarning,
}) {
  return (
    <>
      {error ? <Alert severity="error" sx={{ py: 0.5 }}>{error}</Alert> : null}
      {metadataError ? <Alert severity="error" sx={{ py: 0.5 }}>{metadataError}</Alert> : null}
      {refreshError ? <Alert severity="error" sx={{ py: 0.5 }}>{refreshError}</Alert> : null}
      {refreshTask ? (
        <Alert severity={refreshFailed ? 'error' : refreshSucceeded ? 'success' : 'info'} sx={{ py: 0.35, fontSize: '0.8rem' }}>
          {refreshStatusLabel}
          {refreshTask?.score_date ? ` • ${t('preparation.refresh.forDate', { date: refreshTask.score_date })}` : ''}
        </Alert>
      ) : null}
      {regimeWarning ? <Alert severity="warning" sx={{ py: 0.35, fontSize: '0.8rem' }}>{regimeWarning}</Alert> : null}
    </>
  );
}
